import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    Table,
    Badge,
    Dropdown,
    Button,
    Form,
    InputGroup,
    Spinner,
} from "react-bootstrap";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { getAllVirtTransfers } from "../../http/userAPI";
import CancelTransferModal from "./CancelTransferModal"; // новый компонент модалки
import { toast } from "react-toastify";

const PAGE_SIZE = 50;

const AdminVirtTransfersList = () => {
    const [items, setItems] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    // фильтры — как в UserSearch (Dropdown + компактные инпуты)
    const [status, setStatus] = useState(""); // DONE | PENDING | CANCELED | ""
    const [q, setQ] = useState("");

    const statusOptions = ["DONE", "PENDING", "CANCELED"];

    const totalPages = useMemo(
        () => Math.max(1, Math.ceil(count / PAGE_SIZE)),
        [count]
    );

    const load = async (p = page, s = status, qv = q) => {
        setLoading(true);
        setErr("");
        try {
            const data = await getAllVirtTransfers({
                page: p,
                limit: PAGE_SIZE,
                status: s || undefined,
                q: qv || undefined,
            });
            setItems(Array.isArray(data.items) ? data.items : []);
            setCount(Number(data.count || 0));
        } catch (e) {
            setErr(e?.response?.data?.message || e?.message || "Failed to load transfers");
        } finally {
            setLoading(false);
        }
    };


    const onApplyFilters = () => {
        setPage(1);
        load(1, status, q);
    };

    const onResetFilters = () => {
        setStatus("");
        setQ("");
        setPage(1);
       setItems([]);
    };

    const onPrev = () => {
        if (page > 1) {
            const next = page - 1;
            setPage(next);
            load(next, status, q);
        }
    };
    const onNext = () => {
        if (page < totalPages) {
            const next = page + 1;
            setPage(next);
            load(next, status, q);
        }
    };

    // внутри компонента:
    const [selected, setSelected] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);

    const openCancelModal = (row) => {
        setSelected(row);
        setShowCancelModal(true);
    };

    const onCanceledSuccess = (updated) => {
        // обновим строку в таблице локально
        setItems((prev) =>
            prev.map((it) => (it.id === updated.id ? { ...it, ...updated } : it))
        );
        toast.success("Transfer has been canceled.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
    };

    return (
        <Card className="shadow-sm bg-light p-0">
            <Card.Body>
                {/* Панель фильтров слева + заголовок справа — в точности как в твоём примере */}
                <div className="d-flex flex-wrap gap-2 mb-3 align-items-end justify-content-start">
                    {/* Фильтры + поиск */}
                    <Dropdown onSelect={(value) => setStatus(value || "")}>
                        <Dropdown.Toggle
                            variant="secondary"
                            size="sm"
                            style={{ minWidth: "120px" }}
                        >
                            {status || "Status"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {statusOptions.map((option) => (
                                <Dropdown.Item key={option} eventKey={option}>
                                    {option}
                                </Dropdown.Item>
                            ))}
                            <Dropdown.Divider />
                            <Dropdown.Item eventKey="">Any</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button variant="success" size="sm" onClick={onApplyFilters}>
                        Apply Filter
                    </Button>
                    <Button variant="outline-secondary" size="sm" onClick={onResetFilters}>
                        Reset
                    </Button>
                    {/* Поиск — скрыт на мобилках, виден c md+ */}
                    <div className="d-none d-md-block" style={{ width: 220 }}>
                        <InputGroup size="sm">
                            <Form.Control
                                type="text"
                                className="form-control-sm"
                                placeholder="Search (id/name/email/comment)"
                                value={q}
                                onChange={(e) => setQ(e.target.value)}
                            />
                        </InputGroup>
                    </div>


                    {/* Заголовок справа (виден всегда), уводим вправо только на md+ */}
                    <div className="ms-0 ms-md-auto d-none d-md-block">
                        <strong className="text-muted small">
                            All Internal Transfers ({count})
                        </strong>
                    </div>

                </div>


                {err && <p className="text-danger small mb-2">{err}</p>}

                {loading ? (
                    <div className="d-flex align-items-center gap-2">
                        <Spinner size="sm" /> <small>Loading…</small>
                    </div>
                ) : (
                    <>
                    {items.length > 0 && (<>


                    <>
                        {/* Таблица — как в UserSearch: striped bordered hover size="sm" + small */}
                        <div
                            style={{
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                paddingBottom: "10px",
                            }}
                        >
                            <Table
                                striped
                                bordered
                                hover
                                size="sm"
                                className="table-sm small"
                                style={{ minWidth: "1200px" }}
                            >
                                <thead className="small">
                                <tr className="small">
                                    <th>ID</th>
                                    <th>When</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Sender&nbsp;ID</th>
                                    <th>Sender&nbsp;Name</th>
                                    <th>Sender&nbsp;Plan</th>
                                    <th>Sender&nbsp;E-Mail</th>
                                    <th>Receiver&nbsp;ID</th>
                                    <th>Receiver&nbsp;Name</th>
                                    <th>Receiver&nbsp;Plan</th>
                                    <th>Receiver&nbsp;E-Mail</th>


                                    <th>Message</th>
                                </tr>
                                </thead>
                                <tbody>
                                {items.length === 0 && (
                                    <tr>
                                        <td colSpan={9} className="text-center py-2 text-muted small">
                                            No transfers found.
                                        </td>
                                    </tr>
                                )}

                                {items.map((t) => {
                                    const stamp =
                                        typeof t.created_at === "number"
                                            ? new Date(t.created_at * 1000)
                                            : new Date(t.created_at);

                                    return (
                                        <tr
                                            className="align-start small"
                                            key={t.id}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => openCancelModal(t)}
                                        >
                                            <td className="text-start py-0 px-1 small">{t.id}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {isNaN(stamp)
                                                    ? "—"
                                                    : format(stamp, "dd-MMM-yyyy HH:mm", { locale: enUS })}
                                            </td>
                                            <td className="text-start py-0 px-1 fw-bold small">{t.amount} Virt</td>
                                            <td className="text-start py-0 px-1 small">
                                                <Badge
                                                    bg={
                                                        t.status === "DONE"
                                                            ? "success"
                                                            : t.status === "PENDING"
                                                                ? "warning"
                                                                : "secondary"
                                                    }
                                                >
                                                    {t.status || "—"}
                                                </Badge>
                                            </td>
                                            <td className="text-start py-0 px-1 small">{t.sender_id}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {t.sender_username || "—"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {t.sender_tariff_plan|| "—"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {t.sender_email || "—"}
                                            </td>

                                            <td className="text-start py-0 px-1 small">{t.receiver_id}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {t.receiver_username || "—"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {t.receiver_tariff_plan|| "—"}
                                            </td>

                                            <td className="text-start py-0 px-1 small">
                                                {t.to_email || "—"}
                                            </td>



                                            <td className="text-start py-0 px-1 small">
                                                {t.description || "—"}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </Table>
                        </div>

                        {/* Пагинация — маленькие кнопки как просил */}
                        <div className="d-flex align-items-center justify-content-between mt-2">
                            <small className="text-muted">
                                Page {page} of {totalPages}
                            </small>
                            <div className="d-flex gap-2">
                                <Button
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={onPrev}
                                    disabled={page <= 1}
                                >
                                    Prev
                                </Button>
                                <Button size="sm" onClick={onNext} disabled={page >= totalPages}>
                                    Next
                                </Button>
                            </div>
                        </div>
                    </>
                    </>)}
    </>
                )}
            </Card.Body>
            <CancelTransferModal
                show={showCancelModal}
                onHide={() => setShowCancelModal(false)}
                transfer={selected}
                onSuccess={onCanceledSuccess}
            />
        </Card>

    );
};

export default AdminVirtTransfersList;
